<div *ngIf="showEnvironment && !isMobileBreakpoint">
  {{ environment | async }}
</div>
